module.exports = __webpack_public_path__ + "fonts/Montserrat-Regular.2dd0a1de.eot";